var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"title-div"},[_vm._v("私桩升级")]),_c('ZD-table',{attrs:{"tableColumns":_vm.pageConfig.updateListColumns,"operates":_vm.operates,"tableData":_vm.tableData,"tableConfig":_vm.pageConfig.noSeltableConfig,"selections":_vm.selections},on:{"updateSelections":(sels) => {
            _vm.selections = sels;
          }}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }